export type BulkHitVisibilityOperation = 'hide' | 'unhide';

export interface BulkHitSelection {
  key: string;
  databaseEntityId: string;
  entityName: string;
  hitId: string;
  hitName: string;
  operation: BulkHitVisibilityOperation;
}

export const getBulkHitSelectionKey = (
  databaseEntityId: string,
  hitId: string,
): string => `${databaseEntityId}:${hitId}`;
